/* eslint-disable no-useless-escape */
/*
	Extension method for RegExp
 */
RegExp.escape = function (s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
};
